module.exports = __webpack_public_path__ + "static/media/KS.eeed3a61.svg";